//** Import Modules */
import React, { useEffect, useState } from "react";
import {
  Table,
  Tooltip,
  Space,
  Modal,
  Divider,
  Button,
  Collapse,
  Grid,
  Pagination,
} from "antd";
import EditEventTicketBtn from "../../components/EditEventTicketBtn";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import EventAttendeeList from "../../components/EventAttendeeList";
import AddEventTicketBtn from "../../components/AddEventTicketBtn";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

export default function EventTicketsList(props) {
  const { event } = props;

  const [tickets, setTickets] = useState([]);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { Panel } = Collapse;

  useEffect(() => {
    getTicketData();
  }, [event]);

  const getTicketData = async () => {
    const tickets = await axiosWithAuth().get(
      `${process.env.REACT_APP_BE_API_URL}/api/event-ticket/getEventTickets/${event.id}`
    );

    setTickets([...tickets.data]);
  };

  const deleteTicket = (ticketID) => {
    const APIURL = `${process.env.REACT_APP_BE_API_URL}/api/event-ticket/delete/${ticketID}`;

    if (window.confirm("Are you sure you wish to delete this item?")) {
      axiosWithAuth()
        .delete(APIURL)
        .then((res) => {
          console.log(res);

          const modal = Modal.success({
            title: "Ticket Deleted",
            content: `Ticket was deleted successfully!`,
          });

          setTimeout(() => {
            modal.destroy();
          }, 5000);

          getTicketData();
        })
        .catch((err) => {
          console.log(err.response);

          const modal = Modal.error({
            title: "Error Deleting Ticket",
            content: err.message,
          });

          setTimeout(() => {
            modal.destroy();
          }, 5000);
        });
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
      key: "capacity",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      render: (date) => {
        return moment(date).format("MM/DD/YYYY");
      },
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      render: (date) => {
        return moment(date).format("MM/DD/YYYY");
      },
    },
    {
      title: "Action",
      render: (text) => (
        <Space>
          <EditEventTicketBtn
            event={event}
            editedData={text}
            getTicketData={getTicketData}
          />

          <EventAttendeeList ticket={text} />

          <button
            onClick={() => {
              deleteTicket(text.id);
            }}
            className="dashboardDeleteBtn"
          >
            <Tooltip title="Delete">
              <FontAwesomeIcon icon={faTrashAlt} />
            </Tooltip>
          </button>
        </Space>
      ),
    },
  ];

  const CardListComponent = ({ listItems }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const start = (currentPage - 1) * pageSize;
    const currentItems = listItems.slice(start, start + pageSize);

    return (
      <>
        <Collapse accordion>
          {currentItems.map((item) => (
            <Panel
              key={item.id}
              header={
                <div>
                  <strong>{item.name}</strong>
                </div>
              }
            >
              <p>
                <strong>Name:</strong> {item.name}
              </p>
              <p>
                <strong>Capacity:</strong> {item.capacity}
              </p>
              <p>
                <strong>Start Date:</strong>{" "}
                {moment(new Date(item && item.start_date)).format("MM/DD/YYYY")}
              </p>
              <p>
                <strong>End Date:</strong>{" "}
                {moment(new Date(item && item.end_date)).format("MM/DD/YYYY")}
              </p>
              <Space size="middle">
                <EditEventTicketBtn
                  event={event}
                  editedData={item}
                  getTicketData={getTicketData}
                />

                <EventAttendeeList ticket={item} />

                <Button
                  onClick={() => {
                    deleteTicket(item.id);
                  }}
                  className="dashboardDeleteBtn"
                >
                  <Tooltip title="Delete">
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </Tooltip>
                </Button>
              </Space>
            </Panel>
          ))}
        </Collapse>

        <div style={{ marginTop: 16, textAlign: "center" }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={listItems.length}
            onChange={(page) => setCurrentPage(page)}
            size="small"
          />
        </div>
      </>
    );
  };

  return (
    <div className="event-tickets-list">
      <AddEventTicketBtn event={event} getTicketData={getTicketData} />
      <Divider />
      {/* <Table dataSource={tickets} columns={columns} /> */}
      {screens.md ? (
        <Table dataSource={tickets} columns={columns} />
      ) : (
        <CardListComponent listItems={tickets} />
      )}
    </div>
  );
}
